import { api } from "@/app/api";
import Service from "@/app/service";

export default class ToolboxService extends Service {
  static ping(address) {
    return api.get(`tools/ping/?${this.prepareFilters(address)}`);
  }

  static generatePassword(passwordPayload) {
    return api.get(
      `tools/generate_password/?${this.prepareFilters(passwordPayload)}`
    );
  }

  static generateHtpasswd(user, password) {
    return api.get(
      `tools/htpasswd/?${this.prepareFilters({ user, password })}`
    );
  }

  static spfCheck(address) {
    return api.get(`tools/spf/`, { params: address });
  }

  static httpHeaders(address) {
    return api.get(`tools/http_headers/`, { params: address });
  }

  static checkServices() {
    return api.get("tools/services_status/");
  }

  static bgpRoute(address, router) {
    return api.get(
      `tools/bgp_route/?address=${address}&format=json&router_number=${router}`
    );
  }

  static dnsTool(params) {
    return api.get(`tools/dns_tool/`, {
      params: {
        format: "json",
        ...params
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/toolbox.service.js